import styled from "styled-components";

export const StyledProductionPlanReportDisclaimer = styled.div`
  color: grey;
  font-style: italic;
  margin-top: 50px;
`;
